export default class updateManager {
    constructor(){
    }
    screen(_status,_type){
        switch (_type) {
            case 'full': // --------------- fullscreen (start) --------------- //

                $('html').removeClass('scroll-screen').addClass('full-screen');
                //_status.scroll = false;
                _status.scrollStart = true;
                _status.scrollEnd = true;
                $("#c-scroll").addClass("is-show");

            break; // --------------- fullscreen (end) --------------- //

            case 'scroll': // --------------- normal (start) --------------- //

                $('html').removeClass('full-screen').addClass('scroll-screen');
                //_status.scroll = true;
                if($(".js__section.js__current").scrollTop() === 0){
                    _status.scrollStart = true;
                    _status.scrollEnd = false;
                }
                if($(".js__section.js__current").scrollTop() + _status.h >= $(".js__section.js__current").children('.l-section__inner').innerHeight()) {
                    _status.scrollStart = false;
                    _status.scrollEnd = true;
                    $("#c-scroll").addClass("is-show");
                }

                break; // --------------- show (end) --------------- //
        }

    }
}

